import { BROADCAST_RELOAD_BANNER } from 'actions/Types';

export default (state = true, action) => {
  if (action.type === BROADCAST_RELOAD_BANNER) return false;

  return state;
};
